<template>
  <div class="task-page">
    <div class="header-row">
      <div class="page-title">任务执行情况</div>
      <div class="filter-row">
        <div class="event-filter">
          <van-dropdown-menu direction="down">
            <van-dropdown-item
              v-model="selectedEvent"
              :options="eventOptions"
              placeholder="筛选任务"
            >
              <template #title>
                <div class="event-dropdown-title">
                  <span class="task-title">{{ getEventDisplayText() }}</span>
                </div>
              </template>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
      </div>
    </div>

    <!-- 新增：任务执行情况表格 -->
    <div class="task-exec-list">
      <table class="exec-table">
        <thead>
          <tr>
            <!-- <th>区域</th> -->
            <th>代表</th>
            <th>总任务</th>
            <th>已执行/已忽略</th>
            <th>完成率</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, idx) in summaryRows" :key="idx">
            <!-- <td>{{ row.territory_name }}</td> -->
            <td>{{ row.user_name }}</td>
            <td style="text-align: right;">{{ row.total }}</td>
            <td style="text-align: right;">
              <span class="executed">{{ row.executed }}</span>
              <span class="ignored">/</span>
              <span class="ignored">{{ row.ignored }}</span>
            </td>
            <td style="text-align: right;">
              <span :class="{ 'rate-red': row.execution_rate < 0.3 }">
                {{ (row.execution_rate * 100).toFixed(0) }}%
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem } from 'vant';
import { getTasks, getTaskStat, getSegmentTasks } from '@/api/nba';

export default {
  name: 'TaskPage',
  components: {
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem,
  },
  data() {
    return {
      selectedEvent: localStorage.getItem('selectedEvent') || '',
      tasks: [],
      eventOptions: [],
      pageNum: 1,
      pageSize: 100,
      finished: false,
      listLoading: false,
      userId: '',
      summaryRows: []
    };
  },
  watch: {
    selectedEvent(newVal) {
      localStorage.setItem('selectedEvent', newVal);
      this.resetAndLoad();
    }
  },
  created() {
    this.userId = localStorage.getItem('user_id') || '';
    this.loadCampaignEvents();
  },
  methods: {
    async loadCampaignEvents() {
      try {
        const res = await getSegmentTasks();
        if (res && res.value && Array.isArray(res.value)) {
          this.eventOptions = res.value.map(event => ({
            text: event.campaign_event_name,
            value: event.campaign_event_id
          }));
          this.selectedEvent = this.eventOptions[0]?.value || '';
          this.resetAndLoad();
        }
      } catch (error) {
        console.error('Failed to load campaign events:', error);
      }
    },
    async resetAndLoad() {
      try {
        const res = await getTaskStat(this.selectedEvent);
        if (res && res.data) {
          this.summaryRows = this.getSummaryRows(res.data);
        } else {
          this.summaryRows = [];
        }
      } catch {
        this.summaryRows = [];
      }
    },
    getSummaryRows(data) {
      // 先按完成率升序，再按总任务数降序排列
      return data
        .map(item => ({
          user_name: item.user_name_mr,
          total: item.task_no,
          executed: item.accept_no,
          ignored: item.ignore_no,
          execution_rate: item.execution_rate // 0~1
        }))
        .sort((a, b) => {
          if (a.execution_rate !== b.execution_rate) {
            return a.execution_rate - b.execution_rate;
          }
          return b.total - a.total;
        });
    },
    getEventDisplayText() {
      if (!this.selectedEvent) {
        return '所有任务';
      }
      const selectedOption = this.eventOptions.find(option => option.value === this.selectedEvent);
      return selectedOption ? selectedOption.text : '所有任务';
    },
  }
};
</script>

<style lang="scss" scoped>
.task-page {
  padding: 16px;
  background: #f2f5f9;
  text-align: left;
  height: calc(100vh - env(safe-area-inset-bottom, 0px));
  overflow: auto;

  .header-row {
    // margin-bottom: 16px;

    .page-title {
      font-size: 22px;
      font-weight: 500;
      color: #2c3034;
      padding-left: 4px;
      height: 24px;
      margin-bottom: 12px;
    }

    .filter-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;

      .product-filter {
        min-width: 120px;
        flex: 1;

        ::v-deep .van-dropdown-menu__item {
          justify-content: flex-start;
        }

        .van-dropdown-menu {
          width: 100%;
        }
      }

      .event-filter {
        min-width: 120px;
        flex: 2;
        text-align: left;

        ::v-deep .van-dropdown-menu__item {
          justify-content: flex-start;
        }

        .van-dropdown-menu {
          width: 100%;
        }

        .event-dropdown-title {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 8px;
          width: 100%;

          .task-title {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

}
::v-deep .van-dropdown-menu__bar {
  background: none;
  box-shadow: none;
}

.task-exec-list {
  margin-top: 24px;
  .exec-table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    font-size: 14px;
    th, td {
      border: 1px solid #eee;
      padding: 8px 4px;
      text-align: center;
    }
    th {
      background: #f2f5f9;
      font-weight: 600;
      color: #333;
    }
    td:nth-child(2),
    td:nth-child(3),
    td:nth-child(4) {
      text-align: right;
    }
    .executed {
      color: #0cc160;
      margin-right: 2px;
    }
    .ignored {
      color: #aaa;
      margin-left: 2px;
    }
    tr:nth-child(even) {
      background: #fafafa;
    }
  }
  .rate-red {
    color: #ff4d4f;
  }
}
</style>
